export const tombs = [
    {
        'id': 1,
        'type': 'Blog',
        'title': 'Horror Mexico',
        'text': 'Images of pulp magazines and Mexican horror movies',
        'url': 'https://horrormexico.tumblr.com/',
        'start': '2018',
        'end': '2018',
    },
    {
        'id': 2,
        'type': 'Site',
        'title': 'Pixels 4 ink',
        'text': 'Web design for tattoo studios and independent tattoo artists',
        'url': 'http://juandiegocalero.com/ink/',
        'start': '2014',
        'end': '2018',
    },
    {
        'id': 3,
        'type': 'Project',
        'title': 'Vaya mierda de apocalipsis',
        'text': '🐡',
        'url': 'https://www.instagram.com/p/BjPGcoUAz_2/',
        'start': '2018',
        'end': '2018',
    },
    {
        'id': 4,
        'type': 'Blog',
        'title': 'Patología pro-diseñística',
        'text': 'Este blog explica y expone un poco de mis influencias y el mundo visual, auditivo y táctil al que admiro',
        'url': 'http://generaciondeltemblor.blogspot.com/',
        'start': '2007',
        'end': '2010',
    },
    {
        'id': 5,
        'type': 'Project',
        'title': 'Arte & Rock',
        'text': 'Curso de cartel de arte en el rock y rock en el arte',
        'url': 'https://www.pinterest.es/licuado/arte-y-rock/',
        'start': '2006',
        'end': '2006',
    },
    {
        'id': 6,
        'type': 'Community',
        'title': 'HTML, CSS, Diseño web y la pura variedads',
        'text': 'Learn and share web design',
        'url': 'https://www.facebook.com/groups/webdesignlove',
        'start': '2016',
        'end': '2018',
    },
    {
        'id': 7,
        'type': 'Community',
        'title': 'Salsa diseño',
        'text': 'Diseño gratis para ONGs',
        'url': 'http://losalsa.blogspot.com/',
        'start': '2009',
        'end': '2010',
    },
    {
        'id': 8,
        'type': 'Newsletter',
        'title': 'La pura Variedad newsletter',
        'text': 'Las mejores noticias, recursos, posts de diseño web y más en tu inbox',
        'url': 'https://us4.campaign-archive.com/home/?u=fba439e3d51963f413fe548a5&id=b04faf3940',
        'start': '2016',
        'end': '2016',
    },
    {
        'id': 9,
        'type': 'Youtube',
        'title': 'Historia y La Pura Variedad',
        'text': 'Canal pensando en integrar la historia mundial en latinoamérica y latinoamérica a la historia mundial',
        'url': 'https://www.youtube.com/channel/UC6hOdzW3TCmh8S2sCrnQSJw',
        'start': '2017 ',
        'end': '2017',
    },
    {
        'id': 10,
        'type': 'Project',
        'title': 'Youtuber map',
        'text': 'This map marks where are all the favorite youtube channels',
        'url': 'http://juandiegocalero.com/youtubermap/',
        'start': '2017',
        'end': '2018',
    },
    {
        'id': 11,
        'type': 'Project',
        'title': 'Auikpa toys',
        'text': 'Esculturas hechas con papel mache, adaptación de las artesanías típicas mexicanas conocidas como alebrijes',
        'url': 'https://www.facebook.com/pg/auikpa/photos',
        'start': '2011',
        'end': '2011',
    },
    {
        'id': 12,
        'type': 'Project',
        'title': 'Trueque',
        'text': 'Cambiado mi alma por kebabs',
        'url': 'https://www.behance.net/gallery/1116939/Trueque-Cambiando-mi-alma-por-kebabs',
        'start': '2011',
        'end': '2011',
    },
    {
        'id': 13,
        'type': 'Project',
        'title': 'BCN Afterhours',
        'text': 'Comparte y busca fiesta',
        'url': 'https://www.behance.net/gallery/2175929/Barcelona-Afterhours',
        'start': '2011',
        'end': '2011',
    }
]